// @ts-check
import React from 'react';
import {
  wrapFormComponentWithLabelAndError,
  wrapFormComponentWithError,
} from './StyledFormComponentWrappers';
import connectFormComponentToReduxForm from 'utils/connectFormComponentToReduxForm';
import ToothSelector from '../../../components/ToothSelector';

const RawToothSelector = ({ value, onChange }) => (
  // ReduxForm gives empty strings to fields as the default
  // initial value, but ToothSelector expects an array
  <ToothSelector onChange={onChange} value={value || []} />
);

const RawToothSelectorField = wrapFormComponentWithLabelAndError(RawToothSelector);
RawToothSelectorField.displayName = 'RawToothSelectorField';

const ToothSelectorField = connectFormComponentToReduxForm(RawToothSelectorField);
ToothSelectorField.displayName = 'ToothSelectorField';
export default ToothSelectorField;

const ToothSelectorInput = connectFormComponentToReduxForm(
  wrapFormComponentWithError(RawToothSelector)
);

export { ToothSelectorInput };
